import { Numeric9PlusCircleIcon } from './Numeric9PlusCircleIcon';

/**
 * author: Contributors
 * id 757FDF81-DCCF-4B75-9A2A-9ED3D2DB966E
 * name numeric-9-plus-circle
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-9-plus-circle.svg
 * tags
 * - Alpha / Numeric 
 */
export const NumericNinePlusCircleIcon = Numeric9PlusCircleIcon;
export default NumericNinePlusCircleIcon